import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import { portfolioSelector, portfolioSelectorService} from './portfolioSelector';
import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { portfolioSummary } from './portfolioSummary';
import { portfolioMauritius } from './portfolio.mauritius/portfolio.mauritius';
import { portfolioMauritiusEquity } from './portfolio.mauritius/portfolio.mauritius.equity/portfolio.mauritius.equity';
import { portfolioMauritiusFixedIncome } from './portfolio.mauritius/portfolio.mauritius.fixedincome/portfolio.mauritius.fixedincome';
import { portfolioMauritiusPreciousMetals } from './portfolio.mauritius/portfolio.mauritius.preciousmetals/portfolio.mauritius.preciousmetals';
import { portfolioMauritiusAlternativeInvestments } from './portfolio.mauritius/portfolio.mauritius.alternativeinvestments/portfolio.mauritius.alternativeinvestments';
import { portfolioMauritiusCash } from './portfolio.mauritius/portfolio.mauritius.cash/portfolio.mauritius.cash';
import { portfolioInternational } from './portfolio.international/portfolio.international';
import { portfolioInternationalEquity } from './portfolio.international/portfolio.international.equity/portfolio.international.equity';
import { portfolioInternationalFixedIncome } from './portfolio.international/portfolio.international.fixedincome/portfolio.international.fixedincome';
import { portfolioInternationalPreciousMetals } from './portfolio.international/portfolio.international.preciousmetals/portfolio.international.preciousmetals';
import { portfolioInternationalAlternativeInvestments } from './portfolio.international/portfolio.international.alternativeinvestments/portfolio.international.alternativeinvestments';
import { portfolioInternationalCash } from './portfolio.international/portfolio.international.cash/portfolio.international.cash';
import { summaryView } from './geographyAndSector/summaryView';
import { overview as geographyAndSector } from './geographyAndSector/overview';

export const portfolioModule = 'portfolio';

angular
  .module(portfolioModule, ['LocalStorageModule', 'ngMaterial', 'isoCurrency'])
  .constant("config", constants.Default)
  .service('portfolioRepo', portfolioRepo)
  .service('portfolioUtilities', portfolioUtilities)
  .service('portfolioSelectorService', portfolioSelectorService)
  .component('portfolioSelector', portfolioSelector)
  .component('portfolioSummary', portfolioSummary)
  .component('portfolioMauritius', portfolioMauritius)
  .component('portfolioInternational', portfolioInternational)
  .component('portfolioMauritiusEquity', portfolioMauritiusEquity)
  .component('portfolioMauritiusFixedIncome', portfolioMauritiusFixedIncome)
  .component('portfolioMauritiusPreciousMetals', portfolioMauritiusPreciousMetals)
  .component('portfolioMauritiusAlternativeInvestments',portfolioMauritiusAlternativeInvestments)
  .component('portfolioMauritiusCash', portfolioMauritiusCash)
  .component('portfolioInternationalEquity', portfolioInternationalEquity)
  .component('portfolioInternationalFixedIncome', portfolioInternationalFixedIncome)
  .component('portfolioInternationalPreciousMetals', portfolioInternationalPreciousMetals)
  .component('portfolioInternationalAlternativeInvestments',portfolioInternationalAlternativeInvestments)
  .component('portfolioInternationalCash', portfolioInternationalCash)
  .component('summaryView', summaryView)
  .component('geographyAndSector', geographyAndSector)




// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.index.ts